"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapToCssModules = _interopRequireDefault(require("../../utils/mapToCssModules"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A simple component to render field level help text.
 */
var HelpText = function HelpText(_ref) {
  var className = _ref.className,
      children = _ref.children,
      Tag = _ref.tag,
      cssModule = _ref.cssModule,
      attrs = _objectWithoutProperties(_ref, ["className", "children", "tag", "cssModule"]);

  var classes = (0, _mapToCssModules.default)((0, _classnames.default)(className, {
    'ctrl-help': true
  }), cssModule);
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({}, attrs, {
    className: classes
  }), children);
};

HelpText.defaultProps = {
  className: undefined,
  children: undefined,
  tag: 'div',
  cssModule: undefined
};
HelpText.propTypes = {
  className: _propTypes.default.string,

  /**
   * HTML tag to use for outer wrapper
   */
  tag: _propTypes.default.string,
  children: _propTypes.default.node,
  cssModule: _propTypes.default.string
};
var _default = HelpText;
exports.default = _default;
//# sourceMappingURL=HelpText.js.map